angular.module("app").directive("dateTimePicker", ['$rootScope', '$filter',
    function ($rootScope, $filter) {
        var defaultFormat = "MM/DD/YYYY, HH:mm:ss";

        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                pick12HourFormat: '@',
                language: '@',
                format: '@',
                initValue: '=',
                useCurrent: '@',
                location: '@',
                callback: "&cb"
            },
            link: function (scope, elem, attrs) {
                scope.format = scope.format || defaultFormat;

                if(scope.initValue && scope.initValue.notFormat){
                    if(attrs.ngModel === 'vm.dateTimestamp') {
                        !!scope.initValue.dateTimestamp && (scope.initValue.dateTimestamp = moment.unix(scope.initValue.dateTimestamp).format(scope.format));
                    }else  if (attrs.ngModel === "vm.created_at") {
                        !!scope.initValue.created_at && (scope.initValue.created_at = moment(scope.initValue.created_at).format(scope.format));
                    } else  if(!!scope.initValue) {
                        if(angular.isDefined(attrs.from)) {
                            !!scope.initValue.dateTimeFrom && (scope.initValue.dateTimeFrom = scope.initValue.dateTimeFrom);
                        }
                        else {
                            !!scope.initValue.dateTimeTo && (scope.initValue.dateTimeTo = scope.initValue.dateTimeTo);
                        }
                    }
                } else {
                    if (attrs.ngModel === "vm.dateTimestamp") {
                        !!scope.initValue.dateTimestamp && (scope.initValue.dateTimestamp = moment.unix(scope.initValue.dateTimestamp).format(scope.format));
                    }else if(attrs.ngModel === "vm.created_at") {
                        !!scope.initValue.created_at && (scope.initValue.created_at = $filter("convertDateToUserTimezone")(scope.initValue.created_at, undefined, scope.format));
                    } else  if(!!scope.initValue) {
                        if(angular.isDefined(attrs.from)) {
                            !!scope.initValue.dateTimeFrom && (scope.initValue.dateTimeFrom =  $filter("convertDateToUserTimezone")(scope.initValue.dateTimeFrom, undefined, scope.format));
                        }
                        else {
                            !!scope.initValue.dateTimeTo && (scope.initValue.dateTimeTo = $filter("convertDateToUserTimezone")(scope.initValue.dateTimeTo, undefined, scope.format));
                        }
                    }

                }

                var callBack = scope.callback();

                $(elem).datetimepicker({
                    pick12HourFormat: scope.pick12HourFormat,
                    language: scope.language,
                    useCurrent: true,
                    format: scope.format,
                    timeZone: moment.tz.guess()
                });

                //Local event change
                $(elem).on("dp.change", function (options) {
                    var dateTime = "",
                        dateTimeToSave = undefined;

                    if(!!options.date) {
                        dateTime = options.date.format(scope.format);
                        if(attrs.ngModel === 'vm.dateTimestamp') {
                            dateTimeToSave = options.date.unix();
                        } else {
                            dateTimeToSave = options.date.tz("Asia/Yerevan").format();
                        }
                    }

                    if(angular.isDefined(attrs.from)) {
                        return callBack.call({from: true, element: this}, dateTime, dateTimeToSave);
                    }

                    callBack.call({element: this}, dateTime, dateTimeToSave);
                });

                $(elem).on('blur', function () {

                })

                scope.$on("updateDateTimePicker", function () {
                    $(elem).data().DateTimePicker.date(null);
                })
            }
        };
    }
]);
